import styled from '@emotion/styled';

export const BreadcrumbContainer = styled.div`
    margin: 2em 0;
`;

export const BreadcrumbElement = styled.span`
    text-decoration: none;
    color: var(--minor-accent__enabled__front__default);
    cursor: pointer;
    padding: 0 0.5rem;

    &:hover {
        color: var(--minor-accent__enabled__front__hovered);
        text-decoration: underline;
    }
`;
